'use client';

import { HorizontalEventCard } from '@goodneighbor/ui';
import styles from './registrationComplete.module.scss';
import { parseForEventCardProps } from '@/services/event';
import { Event } from '@goodneighbor/api/schemas/events/event.schema';
import CancellationCard from '../CancellationCard';
import DownloadBanner from '../../../components/DownloadBanner';

export default function RegistrationComplete({
  event,
  organizationName,
  onManageClick
}: {
  event: Event;
  organizationName: string;
  onManageClick?: () => void;
}) {
  return (
    <div className={styles.registrationComplete}>
      <img
        src="/placeholder/celebration.svg"
        className={styles.image}
        aria-hidden
        alt=""
      />
      <div className={styles.textContainer}>
        <p className={styles.text}>Registration complete. You&apos;re in!</p>
        <p className={styles.subtitle}>
          Congrats! You have successfully completed registration for this event.
        </p>
      </div>
      <HorizontalEventCard
        className={styles.eventCard}
        {...parseForEventCardProps(event, organizationName)}
      />
      <div className={styles.cancellation}>
        <CancellationCard onManageClick={onManageClick} />
      </div>
      <DownloadBanner />
    </div>
  );
}
